import React, { useCallback, useEffect } from 'react'
import authService from '../services/AuthService';
import { useHistory } from 'react-router';
import { AUTH_ROUTER } from '../Routers';

const Logout: React.FC = () => {
  const history = useHistory();

  const singOutCurrentUser = useCallback(async () => {
    await authService.signOut();
    history.push(AUTH_ROUTER);
  }, [history])

  useEffect(() => {
    singOutCurrentUser()
  }, [singOutCurrentUser])

  return (<div />)
}

export default Logout
